import React from 'react';

import { IconProps } from './types';

export const CellLocationIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="26"
        viewBox="0 0 26 26"
        width="26"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M21.1123 11.3623C21.1123 6.8682 17.4561 3.2246 12.9577 3.25C8.692 3.2712 5.0781 6.7581 4.8919 11.0153C4.7015 15.4925 7.486 19.6481 11.0831 22.0941C11.265 22.2168 11.4512 22.3395 11.6374 22.4538C12.5176 22.9955 13.639 22.9489 14.5065 22.3861C18.002 20.1052 21.1123 15.6703 21.1123 11.3623Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
        />
        <path
          d="M15.4375 10.5625C15.4375 11.9082 14.3457 13 13 13C11.6543 13 10.5625 11.9082 10.5625 10.5625C10.5625 9.2168 11.6543 8.125 13 8.125C14.3457 8.125 15.4375 9.2168 15.4375 10.5625Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
        />
      </svg>
    );
  },
);
